import Vue from 'vue';

const state = {
  checklistStates: {},
};

const getters = {
  get: state => state.checklistStates,
};

const mutations = {
  set(state, checklistStates) {
    checklistStates.forEach(checklistState => {
      Vue.set(state.checklistStates, checklistState.checklistId, checklistState);
    });
  },
};

const actions = {
  create({ dispatch, commit, getters, rootGetters }, params) {
    commit('set', params);
    return rootGetters['session/ajax'].post('/checklist_states', { checklistStates: params });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
